import { useEffect } from 'react';
import { ChatMarkdown } from '@wundo/ui';
import { useSmoothText } from '@/lib/useSmoothText.ts';

interface StreamingReplyProps {
  text: string;
  /** Called each time more of the reply is on screen, so the list can follow it down. */
  onGrow: () => void;
}

/** A reply being written, unrolling at reading pace rather than in batches. */
export function StreamingReply({ text, onGrow }: StreamingReplyProps) {
  const shown = useSmoothText(text);

  useEffect(() => {
    onGrow();
  }, [shown, onGrow]);

  return <ChatMarkdown>{shown}</ChatMarkdown>;
}
